export default __webpack_public_path__ + "static/media/feedbackDialogImage.1ab0cad4.png";